import { Flex, Loader } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import MeetingContact from 'components/shared/Meeting/MeetingList/MeetingCard/MeetingContact';
import Text from 'components/shared/Text';
import { useCreateMeetingDrawerModal } from 'stores/global/CreateMeetingDrawerModal';
import { createFullName } from 'utils/createFullName';

import Detail from '../Detail';

import s from './CreateWithLead.module.scss';

const CreateWithLead: React.FC = () => {
  const createMeetingDrawerModal = useCreateMeetingDrawerModal();
  const { leadValue, leadLoadingStage } = createMeetingDrawerModal;

  if (!leadValue.value) {
    return null;
  }

  if (leadLoadingStage.isLoading) {
    return (
      <Flex justify="center" align="center" h="100%">
        <Loader />
      </Flex>
    );
  }

  return (
    <Flex gap="md" w="100%" direction="column">
      <Flex direction="column" gap="sm" p="md" className={s.root}>
        <MeetingContact
          title="Клиент"
          fullName={createFullName(leadValue.value.client)}
          phone={leadValue.value.client.phone}
        />
        <Flex gap="xxxs" direction="column">
          <Text c="gray" size="sm">
            Заявка
          </Text>
          <Text>
            {[`#${leadValue.value.id}`, leadValue.value.project?.name, leadValue.value.placeType?.name]
              .filter(Boolean)
              .join(' • ')}
          </Text>
        </Flex>
      </Flex>
      <Detail />
    </Flex>
  );
};

export default observer(CreateWithLead);
